export const ActivityLinkMap = {
  assignedPerformancePlan: "kpi",
  assignmentSalaryRequest: "wccf",
  tsadv$AssignedPerformancePlan: "kpi",
};